import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PanelRootView from './PanelRootView';
import * as ROUTES from '../../../router/Routes';

const PanelRootModule = () => {
  return (
    <ContainerTemplate active={ROUTES.root} routes={[]}>
      <PanelRootView />
    </ContainerTemplate>
  );
};

export default PanelRootModule;
